
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";

/**
 * VendorMergeService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class VendorMergeService<T = unknown> {
    private readonly $apiService = inject(ApiService);
    
    GetVendorMerge(pVendorId: string): Promise<T> {
        return this.$apiService.sendAuth("IVendorMergeService/GetVendorMerge", pVendorId);
    }
    GetVendorMergeMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IVendorMergeService/GetVendorMergeMetadata");
    }
    MergeVendors(pVendorMerge: T): Promise<boolean> {
        return this.$apiService.sendAuth("IVendorMergeService/MergeVendors", pVendorMerge);
    }
}
